import { Settings } from '../api/PagesApi';

export default (settings: Settings) => {
  return (settings.layouts || []).find((l) => l.default) || null;
};
